/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/addPhoneLocation.ts
 * FILE_ID: JOBHUB-QA-PHONE-ADD-LOCATION-001
 * PURPOSE: Add a blank location from a phone sheet, then close that sheet.
 */
import { addBlankArea } from '../addBlankArea'
import type { JobQaTabController } from '../useJobQaTabController'

export function addLocation(controller: JobQaTabController, closeSheet: () => void): void {
  // Reused from: packages/job-hub/src/jobs/tabs/job-qa/addBlankArea.ts (addBlankArea)
  void addBlankArea(controller.workspace, controller.props.jobId).then(closeSheet)
}
